// API Configuration
// Use environment variable if available, otherwise fallback to production URL
export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://backend.clairai.cloud';

// Grafana URL for "View in Grafana" links (baked in at build time; fallback so prod works if env not set)
export const GRAFANA_URL =
  process.env.REACT_APP_GRAFANA_URL ||
  'https://g-0b79e25482.grafana-workspace.us-east-1.amazonaws.com';

// Grafana Prometheus/AMP datasource UID used for AMP metric "View Data" Explore links.
// Must be a real datasource UID (not type name "prometheus") or Explore falls back incorrectly (e.g. Loki).
export const GRAFANA_PROM_DS_UID =
  process.env.REACT_APP_GRAFANA_PROM_DS_UID ||
  'prometheus-clairai';

// Additional API configuration can be added here in the future
export const API_CONFIG = {
  baseURL: API_BASE_URL,
  //  timeout: 30000,
  // Add other configuration options as needed
};

// Log the API URL in development mode
if (process.env.NODE_ENV === 'development') {
  console.log('API Base URL:', API_BASE_URL);
  console.log('Grafana URL:', GRAFANA_URL);
}
